import React, { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import PropTypes from 'prop-types'

export default function Content({ routes }) {
  return (
    <Suspense>
      <Routes>
        {routes.map((route, idx) => {
          return (
            route.element && (
              <Route
                key={idx}
                path={route.path}
                exact={route.exact}
                name={route.name}
                element={<route.element />}
              />
            )
          )
        })}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  )
}

Content.propTypes = {
  routes: PropTypes.array,
}
